import axios from 'axios';

const merger_request_form = {
  namespaced: true,

  state() {
    return {
      data: {},
      errors: {},
      isLoadErrorConflict: false,
      isLoadErrorGone: false,
      isNotFoundResource: false,
      isForbidden: false
    };
  },
  mutations: {
    setData(state, data) {
      state.data = data;
      state.data.is_supervisor = data.is_supervisor;
    },
    setLoadError(state, payload) {
      state.isLoadErrorConflict = (payload.status === 409);
      state.isLoadErrorGone = (payload.status === 410);
      state.isNotFoundResource = (payload.status === 404);
      state.isForbidden = (payload.status === 403);
    },
    clearError(state) {
      state.errors = {};
    },
  },

  actions: {
    approval({ commit } , payload) {
      commit('clearError');
      return new Promise((resolve, reject) => {
        axios.put(
          `/api/brokerage_companies/merger_request/${+(payload.id)}`,
          { status: payload.status })
        .then(() => {
          commit('clearError');
          resolve(true)
        })
        .catch((error) => {
          let handled = false;
          const status = error.response.status;
          if ([404, 409, 410, 403].includes(status)) {
            const httpCode = (status === 410) ? 409 : (status === 404) ? 403 : status;
            commit('setLoadError', { status: httpCode });
            handled = true;
          }
          reject({ handled });
        });
      });
    },
    load({ commit }, payload) {
      commit('clearError');
      return new Promise((resolve, reject) => {
        axios.get(`/api/brokerage_companies/merger_request/${+(payload.id)}`)
        .then((response) => {
          commit('setData', response.data.data);
          resolve(true);
        })
        .catch((error) => {
          let handled = false;
          const status = error.response.status;
          if ([409, 410, 404, 403].includes(status)) {
            commit('setLoadError', { status });
            handled = true;
          }
          reject({ handled });
        });
      });
    },
  }
};

export default merger_request_form;
